import { render, staticRenderFns } from "./dresserDetail.vue?vue&type=template&id=7458a12a&"
import script from "./dresserDetail.vue?vue&type=script&lang=js&"
export * from "./dresserDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports